import { sgmReport } from '@/utils/util';
import { MessageType } from '../actions/common';
import { Middleware } from 'redux';

const buttonMapping: { [key: string]: number } = {
  LC_BUTTON_ENTER: 23,
  LC_BUTTON_TRIANGLE: 3,
  LC_BUTTON_CIRCLE: 2,
  LC_BUTTON_CROSS: 0,
  LC_BUTTON_SQUARE: 1,
  LC_BUTTON_L1: 5,
  LC_BUTTON_R1: 4,
  LC_BUTTON_UP: 24,
  LC_BUTTON_DOWN: 25,
  LC_BUTTON_LEFT: 26,
  LC_BUTTON_RIGHT: 27,
  LC_BUTTON_MINUS: 20,
  LC_BUTTON_R2: 6,
  LC_BUTTON_R3: 10,
  LC_BUTTON_L2: 7,
  LC_BUTTON_L3: 11,
  LC_BUTTON_PLUS: 19,
};
const getDynamicPath = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const values = Array.from(searchParams.values());
  if (values.length === 0) return '/';
  return `/${values.join('/')}`;
};

const sgmReportMiddleware: Middleware = (store) => (next) => (action) => {
  if (action.type !== MessageType.STEERING_OPERATE) {
    return next(action);
  }
  const oldState = store.getState().controlBtn;

  const { steeringOperate } = action.payload || {};
  const { localControlButton } = steeringOperate || {};

  if (!localControlButton) {
    return next(action);
  }

  for (const key in buttonMapping) {
    if (Object.prototype.hasOwnProperty.call(buttonMapping, key)) {
      const index = buttonMapping[key];
      const newValue = localControlButton[index];

      if (newValue === true && oldState[key] === false) {
        sgmReport(
          `${
            window.location.pathname
          }${getDynamicPath()}/button_press/${key}/${localControlButton.join(
            '-'
          )}`,
          localControlButton
        );
      }
    }
  }

  return next(action);
};

export default sgmReportMiddleware;
